import {useState} from "react";
import {useEffect} from "react";
import {Player} from "@lottiefiles/react-lottie-player";
import loadingAnim from "../../assets/lottie/loading.json";
import thumbnail from "./img/Focus-cuate.svg";
import thumbnailInMainPage from "./img/duplicate-cuate.svg";
import React from "react";
import "./UploadThumbnail.scss"
import MainImageCropper from "../raikoImageCropper/mainImageCropper/MainImageCropper";
import {DialogSize, RaikoDefaultDialogPage, RaikoGridOneColumn} from "@moeindal/base-raiko-panel-components";


export default function UploadThumbnail(
    {
        updateAvatar,
        avatarFile,
        loading = false,
        aspectRatio = 3 / 2
    }) {

    const [avatarUrl, setAvatarUrl] = useState("");


    useEffect(() => {
        if (typeof avatarFile !== 'undefined') {
            setAvatarUrl(
                /* new ImageProxyHelper.Builder(avatarFile.toString().replaceAll('http:', 'https:'))
                     .changeQuality(80)
                     .setImageCompressSize(300, 200)
                     .build()*/
                avatarFile.toString().replaceAll('http:', 'https:')
            )
            // setAvatarUrl(avatarFile.toString().replaceAll('http:', 'https:'))
            handleCloseDialog()
        }
    }, [avatarFile]);

    const [openChooseThumbnailDialog, setOpenChooseThumbnailDialog] = useState(false)

    function handleOpenDialog() {
        setOpenChooseThumbnailDialog(true)
    }

    function handleCloseDialog() {
        setOpenChooseThumbnailDialog(false)
    }

    return (
        <>
            <RaikoDefaultDialogPage
                onClose={handleCloseDialog}
                open={openChooseThumbnailDialog}
                pageTitle={"انتخاب تصویر شاخص"}
                dialogSize={DialogSize.SMALL}
            >
                <MainImageCropper updateAvatar={updateAvatar} ASPECT_RATIO={aspectRatio} thumbnail={thumbnail}/>
            </RaikoDefaultDialogPage>
            <RaikoGridOneColumn>
                <div className={"uploadThumbnailLayout"} onClick={handleOpenDialog}>
                    {
                        loading ?
                            <div className={"mainThumbnailCropped"}>
                                <Player
                                    src={loadingAnim}
                                    loop
                                    autoplay
                                    style={{height: '100px', width: '100px'}}
                                />
                            </div> :
                            <img
                                src={avatarUrl && avatarUrl.length > 0 ? avatarUrl : thumbnailInMainPage}
                                alt="thumbnail"
                                className={"mainThumbnailCropped"}
                            />
                    }
                    <div className={"descriptionLayout"}>
                        {
                            avatarUrl && avatarUrl.length > 0 ? "برای تغییر تصویر کلیک نمایید" : "برای انتخاب تصویر کلیک نمایید"
                        }
                    </div>

                </div>
            </RaikoGridOneColumn>
        </>

    )
}